import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { useCountdown } from '../hooks/useCountdown';
import { CHECKOUT_BASE, CHECKOUT_PRO } from '../constants/checkout';
const offers = [{
  badge: '📘',
  name: 'Pack Blanco Perfecto',
  before: '$38.000',
  price: "$19.990 ARS",
  cta: 'Quiero mi pack',
  href: CHECKOUT_BASE,
  featured: false
}, {
  badge: '🏆',
  name: 'Pack + PRO',
  before: '$52.000',
  price: "$27.990 ARS",
  cta: 'Quiero el pack completo',
  href: CHECKOUT_PRO,
  featured: true
}];
export function FinalCta() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section id="checkout" aria-label="Última oportunidad" className="relative scroll-mt-24 overflow-hidden border-b border-ink-700 bg-ink-950 py-16 sm:py-20" data-id="element-51" data-mp="1t511n5sm84b9">
      <div className="hairline pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" data-id="element-52" data-mp="224o5dy8thm7h" />
      <div className="relative mx-auto w-full max-w-page px-5 text-center sm:px-8" data-id="element-53" data-mp="1x5kwg2ppuvu8">
        <p className="tabular display text-2xl text-alert sm:text-3xl" data-id="element-54" data-mp="n6e2nf8ng5t7">
          ⏰ {hours} hs : {minutes} min : {seconds} seg
        </p>
        <h2 className="display mx-auto mt-6 max-w-2xl text-3xl text-bone sm:text-4xl md:text-5xl" data-id="element-55" data-mp="s4xq5k2w5pno">
          Este es el último blanco que cobrás de menos.
        </h2>

        <div className="mt-12 grid gap-6 text-left md:grid-cols-2" data-id="element-56" data-mp="123wp2axuu6xh">
          {offers.map((offer, i) => <motion.div key={offer.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className={`flex flex-col border bg-ink-900 p-7 ${offer.featured ? 'border-bone' : 'border-ink-700'}`} data-id="element-57" data-mp="1658heo84569d" data-mpi={i}>
              <p className="text-xl" aria-hidden="true" data-id="element-58" data-mp="1ptqz6kqshhe1">
                {offer.badge}
              </p>
              <h3 className="display mt-2 text-xl text-bone sm:text-2xl" data-id="element-59" data-mp="1tukonijvr491">{offer.name}</h3>
              <p className="mt-4 text-sm font-semibold text-ash line-through" data-id="element-60" data-mp="3qvgss5cporf5">{offer.before}</p>
              <p className="display text-4xl text-bone" data-id="element-61" data-mp="3lwnggg95v6gk">{offer.price}</p>
              <div className="mt-6" data-id="element-62" data-mp="3i4puut6dett">
                <CtaButton href={offer.href} variant={offer.featured ? 'solid' : 'outline'} size="md" data-id="element-63" data-mp="3j60iy6a3zb0">
                  {offer.cta}
                </CtaButton>
              </div>
            </motion.div>)}
        </div>

        <p className="mt-8 text-xs font-semibold uppercase tracking-[0.16em] text-ash" data-id="element-64" data-mp="dhvkqxlndvuf">
          🔒 Pago seguro · ⚡ 5 min · 🛡️ Garantía 7 días · 💳 Mercado Pago
        </p>
      </div>
    </section>;
}